import { Icon, IconProps } from ".";

export const Link = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path d="M6.01569 23.4399L12.5759 16.9108L14.7532 19.0882L19.0737 14.7677L21.2479 16.942L25.6328 12.5603L23.4243 10.2581L19.1038 14.7365L16.8952 12.5591L23.4554 6L29.9844 12.5602L23.4554 19.0881L21.2479 16.942L16.9275 21.2635L19.1048 23.4409L12.5446 30L6.01569 23.4399ZM14.7189 19.1194L10.3673 23.4399L12.5447 25.6172L16.8963 21.2968L14.7189 19.1194Z" />
    </Icon>
  );
};
